var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"exception"},[_c('div',{staticClass:"exception-img-block"},[_c('div',{staticClass:"img",style:({
        'background-image': `url(${_vm.model.src})`
      })})]),_c('div',{staticClass:"exception-content"},[_c('h1',[_vm._v(_vm._s(_vm.model.title))]),_c('p',{staticClass:"desc"},[_vm._v(_vm._s(_vm.model.desc))]),_c('div',{staticClass:"action"},[_c('a-button',{attrs:{"type":"primary"},on:{"click":_vm.goHome}},[_vm._v("返回首页")])],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }